<template >
    <div 
    :class="'h-swiper_item h-swiper_item-'+swiperType">
        <div class="h-swiper_item-content" v-show="selfIndex === currentIndex">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name:"h-swiper-item",
    data() {
        return {
            selfIndex:"",
            currentIndex:"",
            swiperType:""
        }
    },
    mounted() {
        // 在 this.$parent 中 可以直接获取到上一级的 props 中所有属性
        // this._self 获取当前实例
        this.selfIndex = Number(this._self.$vnode.key);
        this.currentIndex = this.$parent.currentIndex;
        this.swiperType = this.$parent.type;

    },
    // 监听下标的变化 (监听  this.$parent.currentIndex)
    watch: {
        '$parent.currentIndex': function (val, oldVal) {
            this.currentIndex = val
        }

    }
}
</script>

<style scoped lang="less">
.h-swiper_item{
    width: 100%;
    height: 100%;
    position: absolute;
    .h-swiper_item-content{
        width: 100%;
        height: 100%;
        img{
            height: 100%;
            width: 100%;
        }
    }
}
// .h-swiper_item-card{
//     display: flex;
//     justify-content: space-around;
//     .h-swiper_item-content{
//         width: 30%;
//     }
// }
</style>
